import { render, staticRenderFns } from "./claimsEditTabInformation.vue?vue&type=template&id=71c1766b&scoped=true&"
import script from "./claimsEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./claimsEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./claimsEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c1766b",
  null
  
)

export default component.exports